export const PERMISSIONS = {
  VIEW_ORDERS: 1,
  MANAGE_ORDERS: 2,
  VIEW_USERS: 4,
  MANAGE_USERS: 8,
  VIEW_PRICES: 16,
  MANAGE_PRICES: 32,
  MANAGE_CONTENT: 64,
  MANAGE_AFFILIATES: 128, // Superadmin, Admin, Affiliate manager
  MANAGE_PROMOS: 256,
  VIEW_PROMOS: 512,
  VIEW_REPORTS: 1024,
  MANAGE_CONFIG: 2048,
  MANAGE_PUSH_NOTIFICATIONS: 4096,
  VIEW_PUSH_NOTIFICATIONS: 8192,
  MANAGE_SUBSCRIPTIONS: 16384,
  VIEW_ADMINS: 32768,
  MANAGE_ADMINS: 65536,
  VIEW_CONTENT: 131072,
  VIEW_AFFILIATES: 262144, // Superadmin, Admin, Affiliate manager
  VIEW_EMAIL_TEMPLATES: 524288,
  MANAGE_EMAIL_TEMPLATES: 1048576, //Superadmin, Admin, Content manager
  VIEW_KYC_COUNTRIES: 2097152,
  MANAGE_KYC_COUNTRIES: 4194304,
  MANAGE_SHIPPING_STATUS: 16777216, //Superadmin, Admin, Shipping manager
  VIEW_PREPAID_VOUCHERS: 67108864,
  MANAGE_PREPAID_VOUCHERS: 134217728,
};

/**
 * Checks if a user has a specific permission.
 * @param {number} userPermissionBitmask - The permission bitmask returned for the user.
 * @param {number|number[]} requiredPermission - The specific permission bit (or array of bits) to check for.
 * @returns {boolean} True if the user has the permission, false otherwise.
 */
export const hasPermission = (userPermissionBitmask, requiredPermission) => {
  if (userPermissionBitmask === undefined || userPermissionBitmask === null) return false;
  if (Array.isArray(requiredPermission)) {
    return requiredPermission.some((perm) => (userPermissionBitmask & perm) === perm);
  }
  return (userPermissionBitmask & requiredPermission) === requiredPermission;
};

